import { combineReducers } from 'redux';
import insightsReducer from './insightsReducer';
import usageHistoryReducer from './usageHistoryReducer';
import recommendationReducer from './recommendationsReducer';
import { insightsBillAnalysisReducer } from './insightsBillAnalysisReducer';
import insightsUsageReducer from './insightsUsageReducer';
import surveyReducer from './surveyReducers';
import userHashReducer from '../commonReducers/userHashReducer';
import userObjectReducer from '../commonReducers/userObjectReducer';
import userIdentityReducer from '../commonReducers/userIdentityReducer';
import weatherDataReducer from './weatherDataReducer';
import treesWidgetReducer from './treesWidgetReducer';
import itemizationWidgetDataReducer from './itemizationWidgetDataReducer';
import usageSummaryDataReducer from './usageSummaryDataReducer';
import billProjectionDataReducer from './billProjectionDataReducer';
import insightsSimilarHomesReducer from './insightsSimilarHomesReducer';
import communicationPreferencesReducer from '../commonReducers/communicationPreferencesReducer';
import monthlySummaryDataReducer from './monthlySummaryDataReducer';
import translationDataReducer from '../commonReducers/translationDataReducer';
import configsDataReducer from '../commonReducers/configsDataReducer';
import queryParamsReducer from '../commonReducers/queryParamsReducer';
import appliancesReducer from './appliancesReducer';
import ssoReducer from '../commonReducers/ssoReducer';
import smartRecommendationReducer from './smartRecommendationReducer';
import marketplaceDataReducer from './marketplaceReducer';
import recoDetailsReducer from './recoDetailsReducer';

const allReducers = combineReducers({
  insights: insightsReducer,
  usageHistoryData: usageHistoryReducer,
  recommendationsData: recommendationReducer,
  insightsBillAnalysisData: insightsBillAnalysisReducer,
  insightsUsageData: insightsUsageReducer,
  surveyData: surveyReducer,
  userIdentityDetails: userIdentityReducer,
  treesWidgetReducer: treesWidgetReducer,
  userHash: userHashReducer,
  userObject: userObjectReducer,
  weatherDataInformation: weatherDataReducer,
  itemizationWidgetData: itemizationWidgetDataReducer,
  usageSummaryData: usageSummaryDataReducer,
  billProjectionData : billProjectionDataReducer,
  preferencesData : communicationPreferencesReducer,
  monthlySummaryData : monthlySummaryDataReducer,
  similarHomesData: insightsSimilarHomesReducer,
  translationsData: translationDataReducer,
  configs: configsDataReducer,
  queryParams: queryParamsReducer,
  appliances: appliancesReducer,
  sso: ssoReducer,
  smartRecommendationData: smartRecommendationReducer,
  marketplaceData : marketplaceDataReducer,
  recoDetailsData : recoDetailsReducer
})

export default function getDashboardReducers() {
  return allReducers;
}
